import { render, staticRenderFns } from "./changeEquip.vue?vue&type=template&id=06940a3a&scoped=true"
import script from "./changeEquip.vue?vue&type=script&lang=js"
export * from "./changeEquip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06940a3a",
  null
  
)

export default component.exports